export default __webpack_public_path__ + "static/media/Pending.16ec8981.svg";